// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/document-chart-bar.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'document-chart-bar',
  version: 'outline',
  paths: [
    {
      d: 'M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25M9 16.5v.75m3-3v3M15 12v5.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z',
    },
  ],
}
